import { defineAction, object, string } from '~/prix'
import residenceByCommunityAction from './residenceByCommunity.action.json' with { type: 'json' }
import { z } from 'zod'
import { communityObject } from '~/packages/geo/community/communityObject'

const residenceByCommunityDefinition = defineAction({
  ...residenceByCommunityAction,

  input: z.object({
    communityId: z.string().nullish(),
    hasResidenceCitizensDetails: z.boolean().optional().default(false),
  }),
  output: z.object({
    success: z.boolean(),
    total: z.number(),
    message: z.string(),
    data: z.array(
      z.object({
        community: communityObject.nullish(),
        residences: z
          .array(
            z.object({
              residence: z.any(),
              residenceCustomCode: z.string().nullish(),
            }),
          )
          .nullish(),
      }),
    ),
  }),
})

export default residenceByCommunityDefinition
